var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "uk-container uk-margin-large-bottom" }, [
    _c("p", [
      _c("a", { attrs: { href: this.JSparams.buy_page } }, [
        _vm._v(_vm._s(_vm.i18n["trial-subline-text"]))
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "uk-grid-collapse uk-grid-divider uk-child-width-expand@s",
        attrs: { "uk-grid": "" }
      },
      [
        _c("div", { staticClass: "uk-width-1-2@m" }, [
          _vm.status !== "done"
            ? _c(
                "div",
                { staticClass: "form-wrapper", attrs: { id: "form-wrapper" } },
                [
                  _vm.status !== "done"
                    ? _c("div", [
                        _c("ul", { staticClass: "uk-list" }, [
                          _c(
                            "li",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.step === 1,
                                  expression: "step === 1"
                                }
                              ],
                              attrs: { id: "aboutyou" }
                            },
                            [
                              _c("ValidationObserver", {
                                ref: "step1",
                                staticClass: "uk-form-stacked",
                                class: { disabled: _vm.status === "saving" },
                                attrs: { tag: "form", novalidate: "" },
                                on: {
                                  submit: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.toStep(2)
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        var errors = ref.errors
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass:
                                              "uk-child-width-expand@s uk-flex uk-grid-small",
                                            attrs: {
                                              name: "email",
                                              rules: "required",
                                              tag: "div",
                                              "uk-grid": ""
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var failed = ref.failed
                                                    var passed = ref.passed
                                                    var errors = ref.errors
                                                    var classes = ref.classes
                                                    return [
                                                      _c("div", [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "uk-form-label",
                                                            attrs: {
                                                              for: "email"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.i18n[
                                                                  "step3-email"
                                                                ]
                                                              ) + " *"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "uk-form-controls uk-position-relative"
                                                          },
                                                          [
                                                            _c("i", {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    passed &&
                                                                    _vm.checkField !==
                                                                      "email",
                                                                  expression:
                                                                    "passed && checkField !== 'email'"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                            }),
                                                            _vm._v(" "),
                                                            _c("i", {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm.checkField ===
                                                                    "email",
                                                                  expression:
                                                                    "checkField === 'email'"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "fas fa-circle-notch fa-spin uk-form-icon uk-form-icon-flip uk-hidden@m"
                                                            }),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.customer
                                                                      .data
                                                                      .email,
                                                                  expression:
                                                                    "customer.data.email"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "uk-input",
                                                              class: classes,
                                                              attrs: {
                                                                id: "email",
                                                                type: "email"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.customer
                                                                    .data.email
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm.customer
                                                                      .data,
                                                                    "email",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "field-check uk-width-1-4@m"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "uk-visible@s uk-form-label"
                                                            },
                                                            [_vm._v(" ")]
                                                          ),
                                                          _vm._v(" "),
                                                          failed &&
                                                          errors[0] !==
                                                            "duplicate_account" &&
                                                          _vm.checkField !==
                                                            "email"
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-danger"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-times"
                                                                  }),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .i18n[
                                                                          "step3-emailerror"
                                                                        ]
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          failed &&
                                                          errors[0] ===
                                                            "duplicate_account" &&
                                                          _vm.checkField !==
                                                            "email"
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-danger"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-times"
                                                                  }),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .i18n[
                                                                          "step3-emailerror-duplicate"
                                                                        ]
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          passed &&
                                                          _vm.checkField !==
                                                            "email"
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-success uk-visible@m"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-check"
                                                                  })
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("i", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  _vm.checkField ===
                                                                  "email",
                                                                expression:
                                                                  "checkField === 'email'"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "fas fa-circle-notch fa-spin uk-visible@m"
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("ValidationProvider", {
                                            staticClass:
                                              "uk-child-width-expand@s uk-flex uk-grid-small",
                                            attrs: {
                                              name: "emailRepeat",
                                              rules: "required:@email",
                                              tag: "div",
                                              "uk-grid": ""
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var failed = ref.failed
                                                    var passed = ref.passed
                                                    var errors = ref.errors
                                                    var classes = ref.classes
                                                    return [
                                                      _c("div", [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "uk-form-label",
                                                            attrs: {
                                                              for: "emailRepeat"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.i18n[
                                                                  "step3-email-repeat"
                                                                ]
                                                              ) + " *"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "uk-form-controls uk-position-relative"
                                                          },
                                                          [
                                                            _c("i", {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: passed,
                                                                  expression:
                                                                    "passed"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                            }),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.customer
                                                                      .data
                                                                      .emailRepeat,
                                                                  expression:
                                                                    "customer.data.emailRepeat"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "uk-input",
                                                              class: classes,
                                                              attrs: {
                                                                id:
                                                                  "emailJhbfe",
                                                                type: "email"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.customer
                                                                    .data
                                                                    .emailRepeat
                                                              },
                                                              on: {
                                                                paste: function(
                                                                  $event
                                                                ) {
                                                                  $event.preventDefault()
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm.customer
                                                                      .data,
                                                                    "emailRepeat",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "field-check uk-width-1-4@m"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "uk-visible@s uk-form-label"
                                                            },
                                                            [_vm._v(" ")]
                                                          ),
                                                          _vm._v(" "),
                                                          failed &&
                                                          errors[0] !==
                                                            "duplicate_account" &&
                                                          _vm.checkField !==
                                                            "email"
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-danger"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-times"
                                                                  }),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .i18n[
                                                                          "step3-emailerror-repeat"
                                                                        ]
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          passed &&
                                                          _vm.checkField !==
                                                            "email"
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-success uk-visible@m"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-check"
                                                                  })
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("ValidationProvider", {
                                            staticClass:
                                              "uk-child-width-expand@s uk-flex uk-grid-small",
                                            attrs: {
                                              name: "firstName",
                                              rules: "required",
                                              tag: "div",
                                              "uk-grid": ""
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var failed = ref.failed
                                                    var passed = ref.passed
                                                    var errors = ref.errors
                                                    var classes = ref.classes
                                                    return [
                                                      _c("div", [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "uk-form-label",
                                                            attrs: {
                                                              for: "firstName"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.i18n[
                                                                  "step2-firstname"
                                                                ]
                                                              ) + " *"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "uk-form-controls uk-position-relative"
                                                          },
                                                          [
                                                            _c("i", {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: passed,
                                                                  expression:
                                                                    "passed"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                            }),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.customer
                                                                      .data
                                                                      .firstName,
                                                                  expression:
                                                                    "customer.data.firstName"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "uk-input",
                                                              class: classes,
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.customer
                                                                    .data
                                                                    .firstName
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm.customer
                                                                      .data,
                                                                    "firstName",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "field-check uk-width-1-4@m"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "uk-form-label uk-visible@m"
                                                            },
                                                            [_vm._v(" ")]
                                                          ),
                                                          _vm._v(" "),
                                                          failed
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-danger"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-times"
                                                                  }),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .i18n[
                                                                          "step2-firstnameerror"
                                                                        ]
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: passed,
                                                                  expression:
                                                                    "passed"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "uk-form-success uk-visible@m"
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-check"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("ValidationProvider", {
                                            staticClass:
                                              "uk-child-width-expand@s uk-flex uk-grid-small",
                                            attrs: {
                                              name: "lastName",
                                              rules: "required",
                                              tag: "div",
                                              "uk-grid": ""
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var failed = ref.failed
                                                    var passed = ref.passed
                                                    var errors = ref.errors
                                                    var classes = ref.classes
                                                    return [
                                                      _c("div", [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "uk-form-label",
                                                            attrs: {
                                                              for: "lastName"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.i18n[
                                                                  "step2-lastname"
                                                                ]
                                                              ) + " *"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "uk-form-controls uk-position-relative"
                                                          },
                                                          [
                                                            _c("i", {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: passed,
                                                                  expression:
                                                                    "passed"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                            }),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.customer
                                                                      .data
                                                                      .lastName,
                                                                  expression:
                                                                    "customer.data.lastName"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "uk-input",
                                                              class: classes,
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.customer
                                                                    .data
                                                                    .lastName
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm.customer
                                                                      .data,
                                                                    "lastName",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "field-check uk-width-1-4@m"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "uk-form-label uk-visible@m"
                                                            },
                                                            [_vm._v(" ")]
                                                          ),
                                                          _vm._v(" "),
                                                          failed
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-danger"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-times"
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .i18n[
                                                                          "step2-lastnameerror"
                                                                        ]
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: passed,
                                                                  expression:
                                                                    "passed"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "uk-form-success uk-visible@m"
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-check"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("ValidationProvider", {
                                            staticClass:
                                              "uk-child-width-expand@s uk-flex uk-grid-small",
                                            attrs: {
                                              name: "country",
                                              rules: "required",
                                              tag: "div",
                                              "uk-grid": ""
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var failed = ref.failed
                                                    var passed = ref.passed
                                                    var errors = ref.errors
                                                    var classes = ref.classes
                                                    return [
                                                      _c("div", [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "uk-form-label",
                                                            attrs: {
                                                              for: "country"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.i18n[
                                                                  "step2-country"
                                                                ]
                                                              ) + " *"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "uk-form-controls uk-position-relative"
                                                          },
                                                          [
                                                            _c("i", {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: passed,
                                                                  expression:
                                                                    "passed"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "select",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .customer
                                                                        .data
                                                                        .country,
                                                                    expression:
                                                                      "customer.data.country"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "uk-select",
                                                                class: classes,
                                                                attrs: {
                                                                  id: "country"
                                                                },
                                                                on: {
                                                                  change: function(
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal = Array.prototype.filter
                                                                      .call(
                                                                        $event
                                                                          .target
                                                                          .options,
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          return o.selected
                                                                        }
                                                                      )
                                                                      .map(
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          var val =
                                                                            "_value" in
                                                                            o
                                                                              ? o._value
                                                                              : o.value
                                                                          return val
                                                                        }
                                                                      )
                                                                    _vm.$set(
                                                                      _vm
                                                                        .customer
                                                                        .data,
                                                                      "country",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              _vm._l(
                                                                _vm.countries.getNames(
                                                                  _vm.i18n
                                                                    .language
                                                                ),
                                                                function(
                                                                  country,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "option",
                                                                    {
                                                                      key: index,
                                                                      domProps: {
                                                                        value: index
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          country
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          ]
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "field-check uk-width-1-4@m"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "uk-form-label uk-visible@m"
                                                            },
                                                            [_vm._v(" ")]
                                                          ),
                                                          _vm._v(" "),
                                                          failed
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-danger"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-times"
                                                                  }),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .i18n[
                                                                          "step2-countryerror"
                                                                        ]
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: passed,
                                                                  expression:
                                                                    "passed"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "uk-form-success uk-visible@m"
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-check"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          }),
                                          _vm._v(" "),
                                          _vm.duplicateAccount
                                            ? _c("div", {
                                                staticClass: "uk-alert-danger",
                                                attrs: { "uk-alert": "" },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.i18n
                                                      .error_duplicate_account
                                                  )
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.status === "error"
                                            ? _c("div", {
                                                staticClass: "uk-alert-danger",
                                                attrs: { "uk-alert": "" },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.i18n.error_general
                                                  )
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.status !== "error"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "uk-flex uk-flex-right uk-margin-top"
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "uk-button uk-button-primary",
                                                      attrs: {
                                                        type: "submit",
                                                        disabled:
                                                          invalid ||
                                                          _vm.status ===
                                                            "saving" ||
                                                          _vm.checkField !== ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.i18n[
                                                            "button-next"
                                                          ]
                                                        ) + " "
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3298109768
                                )
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.step === 2,
                                  expression: "step === 2"
                                }
                              ],
                              staticClass: "payment uk-position-relative"
                            },
                            [
                              _vm.customer.data.email !== ""
                                ? _c("div", { staticClass: "uk-text-small" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.i18n["trial-subline_setup"]
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "uk-text-bold" },
                                      [_vm._v(_vm._s(_vm.customer.data.email))]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("h2", [
                                _vm._v(
                                  "2. " +
                                    _vm._s(_vm.i18n["step4-headline"]) +
                                    " "
                                ),
                                _c(
                                  "span",
                                  { staticClass: "uk-text-small uk-text-bold" },
                                  [
                                    _vm._v(
                                      "\n                - " +
                                        _vm._s(_vm.i18n["trial-nochargenow"]) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("i", { staticClass: "fas fa-lock fa-xs" })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "uk-margin" }, [
                                _c("div", { staticClass: "uk-form-controls" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "uk-margin-right uk-margin-bottom uk-display-block uk-display-inline@s"
                                    },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "uk-margin-small-right ccardicon",
                                        attrs: {
                                          src:
                                            _vm.wpParams.template_path +
                                            "/assets/img/vue/cc-visa.png"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticClass:
                                          "uk-margin-small-right ccardicon",
                                        attrs: {
                                          src:
                                            _vm.wpParams.template_path +
                                            "/assets/img/vue/cc-mastercard.png"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticClass:
                                          "uk-margin-small-right ccardicon",
                                        attrs: {
                                          src:
                                            _vm.wpParams.template_path +
                                            "/assets/img/vue/cc-amex.png"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticClass:
                                          "uk-margin-small-right ccardicon",
                                        attrs: {
                                          src:
                                            _vm.wpParams.template_path +
                                            "/assets/img/vue/cc-discover.png"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticClass:
                                          "uk-margin-small-right ccardicon",
                                        attrs: {
                                          src:
                                            _vm.wpParams.template_path +
                                            "/assets/img/vue/cc-diners.png"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticClass:
                                          "uk-margin-small-right ccardicon",
                                        attrs: {
                                          src:
                                            _vm.wpParams.template_path +
                                            "/assets/img/vue/cc-jcb.png"
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("ValidationObserver", {
                                ref: "step2",
                                attrs: { tag: "div" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        var errors = ref.errors
                                        var handleSubmit = ref.handleSubmit
                                        return [
                                          _c(
                                            "form",
                                            {
                                              staticClass: "uk-form-stacked",
                                              attrs: { novalidate: "" },
                                              on: {
                                                submit: function($event) {
                                                  $event.preventDefault()
                                                  return handleSubmit(
                                                    _vm.signup
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("ValidationProvider", {
                                                staticClass:
                                                  "uk-child-width-expand@s",
                                                attrs: {
                                                  name: "ccholder",
                                                  rules: "required",
                                                  tag: "div",
                                                  "uk-grid": ""
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(ref) {
                                                        var failed = ref.failed
                                                        var dirty = ref.dirty
                                                        var passed = ref.passed
                                                        var classes =
                                                          ref.classes
                                                        return [
                                                          _c("div", [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "uk-form-label",
                                                                attrs: {
                                                                  for: "email"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.i18n[
                                                                      "step4-ccholder"
                                                                    ]
                                                                  ) + " *"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "uk-form-controls uk-position-relative"
                                                              },
                                                              [
                                                                _c("i", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        dirty &&
                                                                        passed,
                                                                      expression:
                                                                        "dirty && passed"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                }),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .customer
                                                                          .payment
                                                                          .ccard
                                                                          .cardHolder,
                                                                      expression:
                                                                        "customer.payment.ccard.cardHolder"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "uk-input",
                                                                  class: classes,
                                                                  attrs: {
                                                                    type: "text"
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm
                                                                        .customer
                                                                        .payment
                                                                        .ccard
                                                                        .cardHolder
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm
                                                                          .customer
                                                                          .payment
                                                                          .ccard,
                                                                        "cardHolder",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "field-check uk-width-1-4@m"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-label uk-visible@m "
                                                                },
                                                                [_vm._v(" ")]
                                                              ),
                                                              _vm._v(" "),
                                                              dirty && failed
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "uk-form-danger"
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "fas fa-times"
                                                                      }),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .i18n[
                                                                              "step4-ccholdererror"
                                                                            ]
                                                                          )
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        dirty &&
                                                                        passed,
                                                                      expression:
                                                                        "dirty && passed"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "uk-form-success uk-visible@m"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-check"
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              }),
                                              _vm._v(" "),
                                              _c("ValidationProvider", {
                                                staticClass:
                                                  "uk-child-width-expand@s",
                                                attrs: {
                                                  name: "ccnumber",
                                                  rules: "required|credit_card",
                                                  tag: "div",
                                                  "uk-grid": ""
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(ref) {
                                                        var failed = ref.failed
                                                        var dirty = ref.dirty
                                                        var passed = ref.passed
                                                        var classes =
                                                          ref.classes
                                                        return [
                                                          _c("div", [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "uk-form-label",
                                                                attrs: {
                                                                  for:
                                                                    "ccnumber"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.i18n[
                                                                      "step4-ccnumber"
                                                                    ]
                                                                  ) + " *"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "uk-form-controls uk-position-relative"
                                                              },
                                                              [
                                                                _c("i", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        dirty &&
                                                                        passed,
                                                                      expression:
                                                                        "dirty && passed"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                }),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .customer
                                                                          .payment
                                                                          .ccard
                                                                          .cardNumber,
                                                                      expression:
                                                                        "customer.payment.ccard.cardNumber"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "uk-input",
                                                                  class: classes,
                                                                  attrs: {
                                                                    id:
                                                                      "ccnumber",
                                                                    type: "text"
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm
                                                                        .customer
                                                                        .payment
                                                                        .ccard
                                                                        .cardNumber
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm
                                                                          .customer
                                                                          .payment
                                                                          .ccard,
                                                                        "cardNumber",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    }
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                passed
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "uk-text-small"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm
                                                                              .customer
                                                                              .payment
                                                                              .cardType
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "field-check uk-width-1-4@m"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-label uk-visible@m "
                                                                },
                                                                [_vm._v(" ")]
                                                              ),
                                                              _vm._v(" "),
                                                              dirty && failed
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "uk-form-danger"
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "fas fa-times"
                                                                      }),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .i18n[
                                                                              "step4-ccnumbererror"
                                                                            ]
                                                                          )
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        dirty &&
                                                                        passed,
                                                                      expression:
                                                                        "dirty && passed"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "uk-form-success uk-visible@m"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-check"
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              }),
                                              _vm._v(" "),
                                              _c("ValidationProvider", {
                                                staticClass:
                                                  "uk-child-width-expand@s",
                                                attrs: {
                                                  name: "cvc",
                                                  rules: "max:4|min:3",
                                                  tag: "div",
                                                  "uk-grid": ""
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(ref) {
                                                        var failed = ref.failed
                                                        var dirty = ref.dirty
                                                        var passed = ref.passed
                                                        var classes =
                                                          ref.classes
                                                        return [
                                                          _c("div", [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "uk-form-label",
                                                                attrs: {
                                                                  for: "cvc"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.i18n[
                                                                      "step4-ccsecurity"
                                                                    ]
                                                                  ) + " *"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "uk-form-controls uk-position-relative"
                                                              },
                                                              [
                                                                _c("i", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        dirty &&
                                                                        passed,
                                                                      expression:
                                                                        "dirty && passed"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                }),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .customer
                                                                          .payment
                                                                          .ccard
                                                                          .cvc,
                                                                      expression:
                                                                        "customer.payment.ccard.cvc"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "uk-input",
                                                                  class: classes,
                                                                  attrs: {
                                                                    maxlength:
                                                                      "4",
                                                                    name: "cvc",
                                                                    type: "text"
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm
                                                                        .customer
                                                                        .payment
                                                                        .ccard
                                                                        .cvc
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm
                                                                          .customer
                                                                          .payment
                                                                          .ccard,
                                                                        "cvc",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "field-check uk-width-1-4@m"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-label uk-visible@m "
                                                                },
                                                                [_vm._v(" ")]
                                                              ),
                                                              _vm._v(" "),
                                                              dirty && failed
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "uk-form-danger"
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "fas fa-times"
                                                                      }),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .i18n[
                                                                              "step4-ccsecurityerror"
                                                                            ]
                                                                          )
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        dirty &&
                                                                        passed,
                                                                      expression:
                                                                        "dirty && passed"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "uk-form-success uk-visible@m"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-check"
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "uk-child-width-expand@s uk-flex uk-grid-small",
                                                  attrs: { "uk-grid": "" }
                                                },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "uk-form-label",
                                                        attrs: {
                                                          for: "ccExpiryYear"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.i18n[
                                                              "step4-ccexpires"
                                                            ]
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        attrs: { "uk-grid": "" }
                                                      },
                                                      [
                                                        _c(
                                                          "ValidationProvider",
                                                          {
                                                            staticClass:
                                                              "uk-form-controls uk-position-relative uk-width-1-2",
                                                            attrs: {
                                                              vid:
                                                                "ccExpiryYear",
                                                              name:
                                                                "ccExpiryYear",
                                                              rules: "required",
                                                              tag: "div"
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "default",
                                                                  fn: function(
                                                                    ref
                                                                  ) {
                                                                    var dirty =
                                                                      ref.dirty
                                                                    var passed =
                                                                      ref.passed
                                                                    var classes =
                                                                      ref.classes
                                                                    return [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "uk-form-controls uk-position-relative"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              directives: [
                                                                                {
                                                                                  name:
                                                                                    "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value: passed,
                                                                                  expression:
                                                                                    "passed"
                                                                                }
                                                                              ],
                                                                              staticClass:
                                                                                "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "select",
                                                                            {
                                                                              directives: [
                                                                                {
                                                                                  name:
                                                                                    "model",
                                                                                  rawName:
                                                                                    "v-model",
                                                                                  value:
                                                                                    _vm
                                                                                      .customer
                                                                                      .payment
                                                                                      .ccard
                                                                                      .expiryYear,
                                                                                  expression:
                                                                                    "customer.payment.ccard.expiryYear"
                                                                                }
                                                                              ],
                                                                              key:
                                                                                "expyear",
                                                                              staticClass:
                                                                                "uk-select",
                                                                              class: classes,
                                                                              attrs: {
                                                                                id:
                                                                                  "ccExpiryYear"
                                                                              },
                                                                              on: {
                                                                                change: function(
                                                                                  $event
                                                                                ) {
                                                                                  var $$selectedVal = Array.prototype.filter
                                                                                    .call(
                                                                                      $event
                                                                                        .target
                                                                                        .options,
                                                                                      function(
                                                                                        o
                                                                                      ) {
                                                                                        return o.selected
                                                                                      }
                                                                                    )
                                                                                    .map(
                                                                                      function(
                                                                                        o
                                                                                      ) {
                                                                                        var val =
                                                                                          "_value" in
                                                                                          o
                                                                                            ? o._value
                                                                                            : o.value
                                                                                        return val
                                                                                      }
                                                                                    )
                                                                                  _vm.$set(
                                                                                    _vm
                                                                                      .customer
                                                                                      .payment
                                                                                      .ccard,
                                                                                    "expiryYear",
                                                                                    $event
                                                                                      .target
                                                                                      .multiple
                                                                                      ? $$selectedVal
                                                                                      : $$selectedVal[0]
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            _vm._l(
                                                                              _vm.ccyears,
                                                                              function(
                                                                                year
                                                                              ) {
                                                                                return _c(
                                                                                  "option",
                                                                                  {
                                                                                    key: year,
                                                                                    domProps: {
                                                                                      value: year
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        year
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              }
                                                                            ),
                                                                            0
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "ValidationProvider",
                                                          {
                                                            staticClass:
                                                              "uk-form-controls uk-width-1-2",
                                                            attrs: {
                                                              vid:
                                                                "ccExpiryMonth",
                                                              name:
                                                                "ccExpiryMonth",
                                                              rules: "required",
                                                              tag: "div"
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "default",
                                                                  fn: function(
                                                                    ref
                                                                  ) {
                                                                    var dirty =
                                                                      ref.dirty
                                                                    var passed =
                                                                      ref.passed
                                                                    var classes =
                                                                      ref.classes
                                                                    return [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "uk-form-controls uk-position-relative"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              directives: [
                                                                                {
                                                                                  name:
                                                                                    "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value: passed,
                                                                                  expression:
                                                                                    "passed"
                                                                                }
                                                                              ],
                                                                              staticClass:
                                                                                "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "select",
                                                                            {
                                                                              directives: [
                                                                                {
                                                                                  name:
                                                                                    "model",
                                                                                  rawName:
                                                                                    "v-model",
                                                                                  value:
                                                                                    _vm
                                                                                      .customer
                                                                                      .payment
                                                                                      .ccard
                                                                                      .expiryMonth,
                                                                                  expression:
                                                                                    "customer.payment.ccard.expiryMonth"
                                                                                }
                                                                              ],
                                                                              staticClass:
                                                                                "uk-select",
                                                                              class: classes,
                                                                              attrs: {
                                                                                name:
                                                                                  "ccexpiryMonth"
                                                                              },
                                                                              on: {
                                                                                change: function(
                                                                                  $event
                                                                                ) {
                                                                                  var $$selectedVal = Array.prototype.filter
                                                                                    .call(
                                                                                      $event
                                                                                        .target
                                                                                        .options,
                                                                                      function(
                                                                                        o
                                                                                      ) {
                                                                                        return o.selected
                                                                                      }
                                                                                    )
                                                                                    .map(
                                                                                      function(
                                                                                        o
                                                                                      ) {
                                                                                        var val =
                                                                                          "_value" in
                                                                                          o
                                                                                            ? o._value
                                                                                            : o.value
                                                                                        return val
                                                                                      }
                                                                                    )
                                                                                  _vm.$set(
                                                                                    _vm
                                                                                      .customer
                                                                                      .payment
                                                                                      .ccard,
                                                                                    "expiryMonth",
                                                                                    $event
                                                                                      .target
                                                                                      .multiple
                                                                                      ? $$selectedVal
                                                                                      : $$selectedVal[0]
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            _vm._l(
                                                                              _vm.ccmonths,
                                                                              function(
                                                                                month
                                                                              ) {
                                                                                return _c(
                                                                                  "option",
                                                                                  {
                                                                                    key: month,
                                                                                    domProps: {
                                                                                      value: month
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        month
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              }
                                                                            ),
                                                                            0
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "field-check uk-width-1-4@m"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "uk-form-label uk-visible@m"
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                      _vm._v(" "),
                                                      (errors.ccExpiryYear &&
                                                        errors.ccExpiryYear
                                                          .length > 0) ||
                                                      (errors.ccExpiryMonth &&
                                                        errors.ccExpiryMonth
                                                          .length > 0)
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "uk-form-danger"
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-times"
                                                              }),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.i18n[
                                                                      "step4-ccexpireserror"
                                                                    ]
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                errors.ccExpiryYear &&
                                                                errors
                                                                  .ccExpiryYear
                                                                  .length ===
                                                                  0 &&
                                                                _vm.customer
                                                                  .payment.ccard
                                                                  .expiryYear >
                                                                  0 &&
                                                                errors.ccExpiryMonth &&
                                                                errors
                                                                  .ccExpiryMonth
                                                                  .length ===
                                                                  0 &&
                                                                _vm.customer
                                                                  .payment.ccard
                                                                  .expiryMonth >
                                                                  0,
                                                              expression:
                                                                "errors.ccExpiryYear && errors.ccExpiryYear.length === 0 && customer.payment.ccard.expiryYear > 0 && errors.ccExpiryMonth && errors.ccExpiryMonth.length === 0 && customer.payment.ccard.expiryMonth > 0"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "uk-form-success uk-visible@m"
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-check"
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("ValidationProvider", {
                                                staticClass:
                                                  "uk-child-width-expand@s uk-flex uk-grid-small",
                                                attrs: {
                                                  name: "cccountry",
                                                  rules: "required",
                                                  tag: "div",
                                                  "uk-grid": ""
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(ref) {
                                                        var failed = ref.failed
                                                        var dirty = ref.dirty
                                                        var passed = ref.passed
                                                        var errors = ref.errors
                                                        var classes =
                                                          ref.classes
                                                        return [
                                                          _c("div", [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "uk-form-label",
                                                                attrs: {
                                                                  for:
                                                                    "cccountry"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.i18n[
                                                                      "step4-cccountry"
                                                                    ]
                                                                  ) + " *"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "uk-form-controls uk-position-relative"
                                                              },
                                                              [
                                                                _c("i", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: passed,
                                                                      expression:
                                                                        "passed"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "select",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .customer
                                                                            .payment
                                                                            .ccard
                                                                            .country,
                                                                        expression:
                                                                          "customer.payment.ccard.country"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "uk-select",
                                                                    class: classes,
                                                                    attrs: {
                                                                      id:
                                                                        "cccountry"
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        var $$selectedVal = Array.prototype.filter
                                                                          .call(
                                                                            $event
                                                                              .target
                                                                              .options,
                                                                            function(
                                                                              o
                                                                            ) {
                                                                              return o.selected
                                                                            }
                                                                          )
                                                                          .map(
                                                                            function(
                                                                              o
                                                                            ) {
                                                                              var val =
                                                                                "_value" in
                                                                                o
                                                                                  ? o._value
                                                                                  : o.value
                                                                              return val
                                                                            }
                                                                          )
                                                                        _vm.$set(
                                                                          _vm
                                                                            .customer
                                                                            .payment
                                                                            .ccard,
                                                                          "country",
                                                                          $event
                                                                            .target
                                                                            .multiple
                                                                            ? $$selectedVal
                                                                            : $$selectedVal[0]
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  _vm._l(
                                                                    _vm.countries.getNames(
                                                                      _vm.i18n
                                                                        .language
                                                                    ),
                                                                    function(
                                                                      country,
                                                                      index
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key: index,
                                                                          domProps: {
                                                                            value: index
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              country
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  0
                                                                )
                                                              ]
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "field-check uk-width-1-4@m"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-label uk-visible@m"
                                                                },
                                                                [_vm._v(" ")]
                                                              ),
                                                              _vm._v(" "),
                                                              dirty && failed
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "uk-form-danger"
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "fas fa-times"
                                                                      }),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              errors[0]
                                                                            )
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .i18n[
                                                                              "step4-cccountryerror"
                                                                            ]
                                                                          )
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: passed,
                                                                      expression:
                                                                        "passed"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "uk-form-success uk-visible@m"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-check"
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "errorDisplay uk-margin"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.orderSucceeded ===
                                                            false,
                                                          expression:
                                                            "orderSucceeded === false"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "uk-alert uk-alert-danger uk-margin uk-width-1-1"
                                                    },
                                                    [
                                                      _c("div", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.i18n[
                                                              "step4-generalerror"
                                                            ]
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.paymentVerified ===
                                                            false,
                                                          expression:
                                                            "paymentVerified === false"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "uk-alert uk-alert-danger uk-margin uk-width-1-1"
                                                    },
                                                    [
                                                      _c("div", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.i18n[
                                                              "step4-ccvalidationerror"
                                                            ]
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "uk-flex uk-flex-between uk-margin-top"
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "uk-button uk-button-secondary",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: _vm.previousStep
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-left"
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            ["i18n"][
                                                              "button-previous"
                                                            ]
                                                          )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "uk-button uk-button-primary",
                                                      attrs: {
                                                        type: "submit",
                                                        disabled:
                                                          invalid ||
                                                          _vm.checkField !== ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.i18n[
                                                            "button-next"
                                                          ]
                                                        ) + " "
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-arrow-right"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3477549480
                                )
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sidebar" }, [
          _vm.step === 1
            ? _c("div", [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(this["i18n"]["trial-left_sidebar"])
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.step === 2
            ? _c("div", [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      this["i18n"]["trial-left_sidebar_payment"]
                    )
                  }
                })
              ])
            : _vm._e()
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "loading-overlay",
        class: { visible: _vm.status === "saving" }
      },
      [_c("ocLogo", { attrs: { animated: true } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }